module.exports = __webpack_public_path__ + "static/media/rtu_logo_white.5875c371.svg";